import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HeadProvider } from 'react-head';
import configureStore from './configureStore';
import App from './components/App';
import { getCookie } from './utils/dom';

const hydrate = () => {
	const state = window.REDUX_STATE;
	// The selection token from the cookie is added on the client so that it doesn't need to be a cache key in the CDN
	state.checkout.selection.token = getCookie('selection') || null;
	
	const { store } = configureStore(state);

	ReactDOM.hydrate(
		<Provider store={store}>
			<HeadProvider>
				<App />
			</HeadProvider>
		</Provider>,
		document.getElementById('root'),
	);
};

export default hydrate;
